"use strict";

/**
|--------------------------------------------------
| Select2
|--------------------------------------------------
*/

// IMPORT SELECT2 IN E "front-build.mjs" FILE | Avoids jquery conflicts
export const initSelect2 = (selector) => {
	$(selector).select2({
		theme: "bootstrap-5",
		width: '100%',
		minimumResultsForSearch: Infinity
	});
};